import { Outlet } from "@tanstack/react-router";

export function RootRouteComponent() {
  return <Outlet />;
}
